/* 官网路由配置 */

/* layout */
import Layout from '@/views/zaiart/common/layout'
/* 首页 */
const Home = () => import('@/views/zaiart/home/home')
/* 展览 */
const Ticket = () =>
  import(
    /* webpackChunkName: "zaiart-exhibition" */ '@/views/zaiart/exhibition/ticket'
  )
const Exhibition = () =>
  import(
    /* webpackChunkName: "zaiart-exhibition" */ '@/views/zaiart/exhibition/exhibition'
  )
const ExhibitionDetail = () =>
  import(
    /* webpackChunkName: "zaiart-exhibition" */ '@/views/zaiart/exhibition/exhibitionDetail'
  )
/* 笔记 */
const Notes = () =>
  import(/* webpackChunkName: "zaiart-notes" */ '@/views/zaiart/notes/notes')
const NotesDetail = () =>
  import(
    /* webpackChunkName: "zaiart-notes" */ '@/views/zaiart/notes/notesDetail'
  )
/* 作品 */
const Artwork = () =>
  import(
    /* webpackChunkName: "zaiart-artwork" */ '@/views/zaiart/artwork/artwork'
  )
const ArtworkDetail = () =>
  import(
    /* webpackChunkName: "zaiart-artwork" */ '@/views/zaiart/artwork/artworkDetail'
  )
/* 关于我们 */
const About = () => import('@/views/zaiart/about/about')
/* 下载APP */
const Download = () => import('@/views/zaiart/download/download')
/* 用户协议 */
const Agreement = () => import('@/views/zaiart/member/agreement')
/* memberLayout */
const MemberLayout = () => import('@/views/zaiart/member/memberLayout')
/* 注册 */
const Register = () => import('@/views/zaiart/member/register')
/* 登录 */
const Login = () => import('@/views/zaiart/member/login')
/* 忘记密码 */
const ResetPassword = () => import('@/views/zaiart/member/resetPassword')
/* 绑定手机号 */
const BindPhone = () => import('@/views/zaiart/member/bindPhone')
/* 移动端 */
const Mobile = () => import('@/views/zaiart/mobile')
/* 直播 */
const Live = () => import('@/views/zaiart/live/live')
/* 直播admin */
const LiveAdmin = () => import('@/views/zaiart/live/admin')

const License = () => import('@/views/zaiart/common/businessLicense')
const routes = [
  {
    path: '/',
    component: Layout,
    children: [{ path: '', component: Home, meta: { title: '首页' } }]
  },
  {
    path: '/mobile',
    component: Mobile
  },
  {
    path: '/ticket',
    component: Layout,
    children: [
      { path: '', component: Ticket, meta: { title: '购票' } },
      { path: ':id', component: ExhibitionDetail, meta: { title: '展览' } }
    ]
  },
  {
    path: '/live',
    component: Live
  },
  {
    path: '/live/master',
    component: LiveAdmin
  },
  {
    path: '/exhibition',
    component: Layout,
    children: [
      { path: '', component: Exhibition, meta: { title: '展览' } },
      { path: ':id', component: ExhibitionDetail, meta: { title: '展览' } }
    ]
  },
  {
    path: '/notes',
    component: Layout,
    children: [
      { path: '', component: Notes, meta: { title: '笔记' } },
      { path: ':id', component: NotesDetail, meta: { title: '笔记' } }
    ]
  },
  {
    path: '/artwork',
    component: Layout,
    children: [
      { path: '', component: Artwork, meta: { title: '作品' } },
      { path: ':id', component: ArtworkDetail, meta: { title: '作品' } }
    ]
  },
  {
    path: '/about',
    component: Layout,
    children: [{ path: '', component: About, meta: { title: '关于我们' } }]
  },
  {
    path: '/download',
    component: Download,
    meta: { title: 'APP' }
  },
  {
    path: '/member/register',
    component: MemberLayout,
    children: [{ path: '', component: Register, meta: { title: '注册' } }]
  },
  {
    path: '/member/login',
    component: MemberLayout,
    children: [{ path: '', component: Login, meta: { title: '登录' } }]
  },
  {
    path: '/member/reset_password',
    component: MemberLayout,
    children: [
      { path: '', component: ResetPassword, meta: { title: '忘记密码' } }
    ]
  },
  {
    path: '/member/bind_phone',
    component: MemberLayout,
    children: [
      { path: '', component: BindPhone, meta: { title: '绑定手机号' } }
    ]
  },
  {
    path: '/member/agreement',
    component: Layout,
    children: [{ path: '', component: Agreement, meta: { title: '用户协议' } }]
  },
  {
    path: '/business_license',
    component: Layout,
    children: [{ path: '', component: License, meta: { title: '证照' } }]
  }
]

export default routes
